import DateF from './date-f';
import RRuleFacade, {
  DAILY,
  DONT_REPEAT,
  EVERY_MONTH_ON_DAY,
  EVERY_MONTH_ON_WEEKDAY,
  EVERY_TWO_WEEKS,
  EVERY_WEEK,
  EVERY_WEEKDAY,
  RepeatInterval,
} from './rrule-facade';

export type ScheduleOption = {
  label: string;
  value: string;
};

export const NO_DATE_OPTION: ScheduleOption = {
  label: "Don't repeat",
  value: DONT_REPEAT,
};

export interface RecordSeriesProps {
  date?: DateF;
  rrule?: string | null;
  RRuleUtil?: RRuleFacade;
}

interface RecordSeries extends RecordSeriesProps {}
// eslint-disable-next-line no-redeclare
class RecordSeries {
  constructor({ date, rrule }: RecordSeriesProps = {}) {
    this.date = date;
    this.rrule = rrule || null;
    if (date) {
      this.RRuleUtil = new RRuleFacade(date);
    }
  }

  getScheduleOptions(): ScheduleOption[] {
    if (!this.date) {
      return [NO_DATE_OPTION];
    }
    return [
      { label: "Don't repeat", value: DONT_REPEAT },
      { label: 'Daily', value: DAILY },
      { label: 'Weekly', value: EVERY_WEEK },
      { label: 'Bi-Weekly', value: EVERY_TWO_WEEKS },
      { label: 'Every weekday (mon-fri)', value: EVERY_WEEKDAY },
      {
        label: `Every month (on the ${this.date.toOrdinalSuffixWeekOfMonth()} ${this.date.toWeekdayString()})`,
        value: EVERY_MONTH_ON_WEEKDAY,
      },
      {
        label: `Every ${this.date.toOrdinalSuffixDay()} of the month`,
        value: EVERY_MONTH_ON_DAY,
      },
    ];
  }

  getSelectedOptionValue(): RepeatInterval {
    if (!this.date || !this.RRuleUtil || !this.rrule) {
      return DONT_REPEAT;
    }
    return RRuleFacade.getIntervalFromRRule(this.rrule);
  }

  getRRuleFromInterval(interval: RepeatInterval): string | null | undefined {
    return this.RRuleUtil?.getRRuleFromInterval(interval);
  }

  update({ date, rrule }: RecordSeriesProps): RecordSeries {
    if (!date) return new RecordSeries();

    let newRRule = rrule;
    if (!date.isEqualTo(this.date)) {
      const newRRuleUtil = new RRuleFacade(date);
      const currentInterval = this.getSelectedOptionValue();
      newRRule = newRRuleUtil.getRRuleFromInterval(currentInterval);
    }
    const newRecordSeries = new RecordSeries({ date, rrule: newRRule });
    return newRecordSeries;
  }

  updateRRule(rrule?: string): RecordSeries {
    return new RecordSeries({ date: this.date, rrule });
  }
}

export default RecordSeries;
